import { Box } from 'braid-design-system';
import React from 'react';

export default () => (
  <Box>
    <svg
      width="102px"
      height="78px"
      viewBox="0 0 102 78"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ThankYouTick</title>
      <g
        id="Success-page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="1-Beta--Success-page-B-Copy-5"
          transform="translate(-175.000000, -124.000000)"
        >
          <g id="1-Title" transform="translate(176.000000, 125.000000)">
            <g id="Icon">
              <path
                d="M81.3723913,40.5050725 C81.3723913,30.9398551 73.5463043,23.1137681 63.981087,23.1137681 L21.9521014,23.1137681 C12.3868841,23.1137681 4.5607971,30.9398551 4.5607971,40.5050725 L4.5607971,65.8673913 C4.5607971,71.4471014 9.12601449,76.0123188 14.7057246,76.0123188 L71.2274638,76.0123188 C76.8071739,76.0123188 81.3723913,71.4471014 81.3723913,65.8673913 L81.3723913,40.5050725 Z"
                id="Fill-1"
                fill="#CEEAC9"
              />
              <path
                d="M38.594058,50.2452174 C19.625942,49.8017391 8.49115942,46.5944928 3.38826087,44.6365217 C1.34188406,43.8517391 -0.000144927536,41.8771014 -0.000144927536,39.6857971 L-0.000144927536,19.4046377 C-0.000144927536,15.0321739 3.54478261,11.4872464 7.91797101,11.4872464 L56.6295652,11.4872464 L56.6295652,6.24666667 C56.6295652,2.79666667 53.8324638,0.000289855072 50.3824638,0.000289855072 L35.7715942,0.000289855072 C32.3215942,0.000289855072 29.5244928,2.79666667 29.5244928,6.24666667 L29.5244928,11.4872464"
                id="Stroke-3"
                stroke="#031D44"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M62.7922464,49.1788406 C58.4038406,49.7157971 53.3335507,50.11 47.5313768,50.2455072"
                id="Stroke-5"
                stroke="#031D44"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M47.3848551,50.2965217 C47.3848551,52.6755072 45.4558696,54.6044928 43.0768841,54.6044928 C40.6978986,54.6044928 38.768913,52.6755072 38.768913,50.2965217 C38.768913,47.9175362 40.6978986,45.9892754 43.0768841,45.9892754 C45.4558696,45.9892754 47.3848551,47.9175362 47.3848551,50.2965217 Z"
                id="Stroke-7"
                stroke="#031D44"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M100,26.7649275 C100,38.8424638 90.2094203,48.6330435 78.1318841,48.6330435 C66.0543478,48.6330435 56.2637681,38.8424638 56.2637681,26.7649275 C56.2637681,14.6873913 66.0543478,4.89681159 78.1318841,4.89681159 C90.2094203,4.89681159 100,14.6873913 100,26.7649275 Z"
                id="Stroke-9"
                stroke="#031D44"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M89.3497826,18.4627536 L75.0526812,34.6772464 C74.5338406,35.1968116 73.6925362,35.1968116 73.1736957,34.6772464 L66.9142754,26.9649275 L74.0932609,29.477971 L89.3497826,18.4627536 Z"
                id="Stroke-11"
                stroke="#031D44"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Box>
);
